<template>
  <div>
    <!-- Safe Dig Indiana: custom maintenance message -->
    <template v-if="isSafeDig">
      <div class="safedig-404-page">
        <SafeDigHeader />
        <div class="safedig-404-main">
          <div class="safedig-404-content">
            <img src="../../assets/safe-dig/maintenance.jpg" alt="Safe Dig Indiana" class="safedig-404-icon">
            <h1 class="safedig-404-title">{{ $t('notFound.maintenanceMessage') }}</h1>
            <router-link to="/login" class="safedig-404-link">Return to Safe Dig Indiana</router-link>
          </div>
        </div>
        <div class="siteFooter footerOffWhite safedigFooter safedig404Footer">
          <div class="safedigCustomFooter">
            <div>
              <img src="../../assets/safe-dig/safedig_logo_grayscale-01.png" class="safedigindiana811Logo"
                alt="Safe Dig Indiana" />
            </div>
            <p class="copyright">
              {{ $t('footer.copyright', { year }) }}<br>
              {{ $t('footer.allRightsReserved') }}
            </p>
          </div>
        </div>
      </div>
    </template>
    <!-- Default: generic 404 -->
    <template v-else>
      <div class="header bg-gradient-info py-7 py-lg-8 pt-lg-9">
        <div class="container">
          <div class="header-body text-center mb-7">
            <div class="row justify-content-center">
              <div class="col-xl-5 col-lg-6 col-md-8 px-5">
                <h1 class="text-light">Ooops!</h1>
                <p class="text-lead text-white">Page not found. Don't worry though, we have plenty of other pages to
                  explore</p>

                <router-link to="/dashboard" class="font-weight-bold text-white mt-5">Back to dashboard</router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="separator separator-bottom separator-skew zindex-100">
          <svg x="0" y="0" viewBox="0 0 2560 100" preserveAspectRatio="none" version="1.1"
            xmlns="http://www.w3.org/2000/svg">
            <polygon class="fill-default" points="2560 0 2560 100 0 100"></polygon>
          </svg>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import SafeDigHeader from '@/components/safe-dig/Header.vue';

export default {
  name: 'not-found',
  components: {
    SafeDigHeader
  },
  data() {
    return {
      year: new Date().getFullYear()
    };
  },
  computed: {
    isSafeDig() {
      return process.env.VUE_APP_COMPANY_NAME_FRONTEND === 'safedig';
    }
  }
};
</script>

<style scoped>
.safedig-404-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.safedig-404-main {
  flex: 1;
  min-height: 60vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem 3rem;
  background: #f5f7fa;
}

.safedig-404-content {
  text-align: center;
  max-width: 700px;
  background: #fff;
  border-radius: 4px;
  border-top: 4px solid #94bcd5;
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.12), 0 2px 4px 0 rgba(0, 0, 0, 0.08);
  padding: 2.5rem 2rem;
}

.safedig-404-icon {
  display: block;
  width: 260px;
  height: auto;
  margin: 0 auto 1.5rem;
}

.safedig-404-icon svg {
  width: 100%;
  height: 100%;
}

/* Safe Dig footer (matches SafeDigLogin, SafeDigRegister) */
.siteFooter {
  width: 100%;
}

.footerOffWhite {
  background: #e8e8e8;
}

.safedig404Footer .safedigCustomFooter {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem 1.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1.5rem;
}

.safedigindiana811Logo {
  height: 60px;
  width: auto;
}

.copyright {
  margin: 0;
  color: #6b6b6b;
  font-size: 0.85rem;
  line-height: 1.5;
}

.safedig-404-title {
  font-size: 1.5rem;
  line-height: 1.6;
  color: #1e3a5f;
  margin: 0 0 1.5rem;
}

.safedig-404-link {
  color: #3e7799;
  font-weight: 600;
  text-decoration: none;
}

.safedig-404-link:hover {
  text-decoration: underline;
  color: #2d5a73;
}
</style>
 